// extracted by mini-css-extract-plugin
export default {"dashboardBase":"DashboardBase_dashboardBase__oZHBv","dashboardContent":"DashboardBase_dashboardContent__vSvv8","jobsDashboardContent":"DashboardBase_jobsDashboardContent__JBwWw"};